<template>
    <div :style="{ '--divWidth--': divWidth, '--divHeight--': divHeight, 'position': IsBigDiv ? 'fixed' : 'static', }"
        style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1000 !important;background-color: white;
    background-image: url(../../../static/banner/bigScreen.jpg);background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;">
        <div style="width: 100%;margin-top: 5%;display: flex;height: 88%;flex-wrap: wrap;" v-if="Statistics_data.length >0">
            <template v-for="(item, index) in Statistics_data" >
                <div style="width: 10%;height: 50%;">
                    <c-echartsu width="100%" height="100%" :echartsData="item" style="width: 100%;height: 85%;"></c-echartsu>
                    <!-- <div :ref="'eCharts' + index" style="width: 100%;height: 80%;"></div> -->
                    <div style="width: 100%;color: white;font-size:1.5rem;text-align: center;margin: 0.5rem 0;" @click="gotoUser(item)">{{ item.ytsuName }}</div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'departmentBigscreen',
    components: {

    },
    data() {
        let this_ = this
        return {
            ringConfig: {
                radius: '75%',
                activeRadius: '80%',
                data: [],
                digitalFlopStyle: {
                    fontSize: this_.nowSize(15)
                },
                showOriginValue: true,
            },
            ringConfig2: {
                radius: '75%',
                activeRadius: '80%',
                data: [],
                digitalFlopStyle: {
                    fontSize: this_.nowSize(15)
                },
                showOriginValue: true,
            },
            ringConfig3: {
                radius: '75%',
                activeRadius: '80%',
                data: [],
                digitalFlopStyle: {
                    fontSize: this_.nowSize(15)
                },
                showOriginValue: true,
            },
            ringConfig4: {
                radius: '75%',
                activeRadius: '80%',
                data: [],
                digitalFlopStyle: {
                    fontSize: this_.nowSize(15)
                },
                showOriginValue: true,
            },

           

            color: [
                ' #4992ff',
                ' #dd79ff',
                ' #fddd60',
                '  #ff6e76',
                ' #58d9f9',
                ' #05c091',
                '  #ff8a45',
                ' #8d48e3',
            ],
            Statistics_data: [],
            theUserProject: null,
            divWidth: '100%',
            divHeight: '100%',
            IsBigDiv: true,
            config: {
                data: [

                ],
                columnWidth: [100000],
                align: ['center'],
                oddRowBGC: 'none',
                evenRowBGC: 'rgba(38,81,207, 0.3)'
            },
        }
    },
    watch: {
        divWidth(n, v) {
            console.log(n);
            this.ringConfig = { ...this.ringConfig }
            this.ringConfig2 = { ...this.ringConfig2 }
            this.ringConfig3 = { ...this.ringConfig3 }
            this.ringConfig4 = { ...this.ringConfig4 }
            // setTimeout(() => {

            //     this.$refs['scrollBoard'].updateRows(this.config.data)
            //     this.$refs.box2.initWH()
            //     this.$refs.box3.initWH()
            //     this.$refs.box4.initWH()
            //     this.$refs.box5.initWH()
            //     this.$refs.box6.initWH()
            //     this.$refs.box7.initWH()
            //     this.echartsStr.resize()
            //     this.echartsStr2.resize()
            //     this.echartsStr3.resize()
            //     this.echartsStr4.resize()

            // }, 300)
        },
    },
     created() {
       
        this.theUserProject = A.local('$projectId');
        const id = A.local('ytsdId')
        this.getTemStatisticUserList({ ytsdId: id, }).result(res => {
            console.log(res);
            const data = res.data.data;
             data.forEach((item,index)=>{
                item.titleOne = '个人企宽到期总量与续费条数'
             });
             this.Statistics_data = data
            if (this.IsBigDiv) {
                this.divHeight = '100vh';
                this.divWidth = '100vw';
            } else {
                this.divHeight = '100%';
                this.divWidth = '100%';
            }
        });
        //    var timer  =  setInterval(() => {
        //         setTimeout(() => {
        //             ///调取接口
        //             this.getLargeScreenStatistics({ projectId: this.theProjectId, }).result(res => {
        //                 this.Statistics_data = res.data.data;
        //                 const config_data = []
        //                 res.data.data.resultList.forEach((item, index) => {
        //                     const data = [`<div class="scrollboard" >${item}</div>`]
        //                     config_data.push(data)
        //                 });
        //                 this.config.data = config_data;
        //                 if (this.IsBigDiv) {
        //                     this.divHeight = '100vh';
        //                     this.divWidth = '100vw';
        //                 } else {
        //                     this.divHeight = '100%';
        //                     this.divWidth = '100%';
        //                 }
        //             });
        //             this.getEchartsValue()
        //         }, 0);
        //     },  5 * 60000);

    },
    mounted() {
      
        // setTimeout(() => {
        //     this.$refs['scrollBoard'].updateRows(this.config.data)
        //     this.$refs.box2.initWH()
        //     this.$refs.box3.initWH()
        //     this.$refs.box4.initWH()
        //     this.$refs.box5.initWH()
        //     this.$refs.box6.initWH()
        //     this.$refs.box7.initWH()

        // }, 100)
      
        const _this = this
        window.addEventListener('resize', function () {
            console.log('改变了');
            // _this.echartsStr.resize()
            // _this.echartsStr2.resize()
            // _this.echartsStr3.resize()
            // _this.echartsStr4.resize()
            //     _this.echartsStr5.resize()
            //     _this.echartsStr6.resize()
            // setTimeout(() => {
            //     _this.$refs['scrollBoard'].updateRows(_this.config.data)
            //     _this.$refs.box2.initWH()
            //     _this.$refs.box3.initWH()
            //     _this.$refs.box4.initWH()
            //     _this.$refs.box5.initWH()
            //     _this.$refs.box6.initWH()
            //     _this.$refs.box7.initWH()
            // }, 100)

        });
    },

    methods: {
        gotoUser(data){
            this.$push('SelectProject');
        },
        // 图标配置项
        DrawEcharts() {
            var that = this
            console.log(this.$refs);
            if( this.Statistics_data.length > 0){
                this.Statistics_data.forEach((item, index) => {
                console.log( this['echartsStr' + index]);
                this['echartsStr' + index] = this.$echarts.init(this.$refs[`eCharts+ ${index}`])
                
                console.log(this['echartsStr' + index]);
                let total = item.ytsdSix;//总量
                let salayry1 = item.ytsdFour;//网格
                let salayry2 = item.ytsdTwo;//客户经理

                let option = {
                    color: [
                        "#00FFFF",
                        "#00B0FF",
                        "#FFC000",
                        "#FFAB6F",
                        "#63E315",
                        "#893BFF",
                    ],
                    legend: {
                        orient: "vertical",
                        left: "10%",
                        top: "20%",
                        itemHeight: 12, //图例的高度
                        itemGap: 15, //图例之间的间距
                        data: [
                            {
                                name: "企宽到期总量与续费条数(累计)",
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                            {
                                name: "企宽到期总量与续费条数(网格)",
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                            {
                                name: "企宽到期总量与续费条数(经理)",
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                          
                        ],
                        //图例的名字需要和饼图的name一致，才会显示图例
                    },
                    series: [
                        // A版块
                        {
                            name: "企宽到期总量与续费条数(累计)",
                            type: "pie",
                            radius: ["70%", "75%"],
                            center: ["65%", "50%"],
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: this.nowSize(20),
                                    fontWeight: "bold",
                                },
                            },
                            data: [
                                {
                                    value: item.ytsdFive, //需要显示的数据
                                    name: 80 + "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#00FFFF",
                                        },
                                    },
                                },
                                {
                                    value: item.ytsdSix - item.ytsdFive,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                        // B版块
                        {
                            name: "企宽到期总量与续费条数(累计)",
                            type: "pie",
                            radius: ["60%", "65%"],
                            center: ["65%", "50%"],
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: "20",
                                    fontWeight: "500",
                                },
                            },
                            data: [
                                {
                                    value: item.ytsdThree, //需要显示的数据
                                    name: salayry2 + "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#00B0FF",
                                        },
                                    },
                                },
                                {
                                    value: item.ytsdFour - item.ytsdThree,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                        // C版块
                        {
                            name: "企宽到期总量与续费条数(经理)",
                            type: "pie",
                            radius: ["50%", "55%"],
                            center: ["65%", "50%"],
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: "20",
                                    fontWeight: "bold",
                                },
                                itemStyle: {
                                    normal: {
                                        color: "#FFC000",
                                    },
                                },
                            },
                            data: [
                                {
                                    value: item.ytsdTwo, //需要显示的数据
                                    name: salayry3 + "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#FFC000",
                                        },
                                    },
                                },
                                {
                                    value: item.ytsdOne - item.ytsdTwo,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                    
                    ],
                };
                this['echartsStr' + index].setOption(option);
            })
            }
        

        },
        async getEchartsValue() {
            var date = new Date();
            var year = date.getFullYear();
            var that = this;
            console.log(year);
            await this.getLargeScreenStatisticsDt({ projectId: this.theUserProject }).result(res => {
                const data = res.data.data;
                this.echartsValue.xdata = data.dayList
                const allYAxis = [];
                const allYAxis2 = [];
                const allYAxis3 = [];
                const allYAxis4 = [];
                const rang_config = [];
                const rang_config2 = [];
                const rang_config3 = [];
                const rang_config4 = [];
                data.departmentList.forEach((element, index) => {
                    const yAxis = {
                        name: element.dtName,
                        type: 'line',
                        id: element.dtId,
                        stack: 'Total',
                        areaStyle: {},
                        smooth: true,
                        emphasis: {
                            focus: 'series'
                        },
                        data: []
                    }
                    const yAxis2 = {
                        name: element.dtName,
                        id: element.dtId,
                        type: 'bar',
                        barGap: 1,
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            // 柱图头部显示值
                            show: true,
                            position: "top",
                            color: "white",
                            fontSize: this.nowSize(13),
                            formatter: (params) => {
                                return params.value[params.encode.x[0]];
                            },
                        },
                        data: []
                    }
                    const yAxis3 = {
                        name: element.dtName,
                        type: 'line',
                        id: element.dtId,
                        stack: 'Total',
                        areaStyle: {},
                        smooth: true,
                        emphasis: {
                            focus: 'series'
                        },
                        data: []
                    }
                    const yAxis4 = {
                        name: element.dtName,
                        id: element.dtId,
                        type: 'bar',
                        barGap: 1,
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            // 柱图头部显示值
                            show: true,
                            position: "top",
                            color: "white",
                            fontSize: this.nowSize(13),
                            formatter: (params) => {
                                return params.value[params.encode.x[0]] != 0 ? that.fmoney(params.value) : params.value[params.encode.x[0]];
                            },
                        },
                        data: []
                    }
                    allYAxis.push(yAxis);
                    allYAxis2.push(yAxis2);
                    allYAxis3.push(yAxis3);
                    allYAxis4.push(yAxis4);
                    data.dayList.forEach((week, weekIndeex) => {
                        data.largeScreenVisitorDayResult.forEach((item, id) => {
                            if (element.dtId == item.dtId && `${year}-${week}` == item.dataDate) {
                                allYAxis[index].data.push(item.visitorNum)
                            }
                        })
                    })
                    data.dataDateWeekList.forEach((week, weekIndeex) => {
                        data.largeScreenVisitorWeekResult.forEach((item, id) => {
                            if (element.dtId == item.dtId && week == item.dataDate) {
                                allYAxis2[index].data.push(item.visitorNum)
                            }
                        })
                    })
                    data.dayList.forEach((week, weekIndeex) => {
                        data.largeScreenOrderDayResult.forEach((item, id) => {
                            if (element.dtId == item.dtId && `${year}-${week}` == item.dataDate) {
                                allYAxis3[index].data.push(item.userKpi)
                            }
                        })
                    })
                    data.dataDateWeekList.forEach((week, weekIndeex) => {
                        data.largeScreenOrderWeekResult.forEach((item, id) => {
                            if (element.dtId == item.dtId && week == item.dataDate) {
                                allYAxis4[index].data.push(item.userKpi)
                            }
                        })
                    })

                });
                data.largeScreenOrderNumsResult.forEach((item, index) => {
                    const s = { name: item.dtName, value: item.userKpi };
                    const s2 = { name: item.dtName, value: item.userNum };
                    rang_config.push(s);
                    rang_config2.push(s2);
                })
                data.largeScreenVisitorNumsResult.forEach((item, index) => {
                    const s = { name: item.dtName, value: item.visitorNum };
                    const s2 = { name: item.dtName, value: item.userNum };
                    rang_config3.push(s);
                    rang_config4.push(s2);
                })
                this.echartsValue.data = allYAxis;
                this.echartsValue2.xdata = data.dataDateWeekListResultRank;
                this.echartsValue2.xdata2 = data.dateWeekRankList;
                this.echartsValue2.data = allYAxis2;
                this.echartsValue3.xdata = data.dayList;
                this.echartsValue3.data = allYAxis3;
                this.echartsValue4.xdata = data.dataDateWeekListResultRank;
                this.echartsValue4.xdata2 = data.dateWeekRankList;
                this.echartsValue4.data = allYAxis4;
                this.ringConfig.data = rang_config;
                this.ringConfig = { ...this.ringConfig }
                this.ringConfig2.data = rang_config2;
                this.ringConfig2 = { ...this.ringConfig2 }
                this.ringConfig3.data = rang_config3;
                this.ringConfig3 = { ...this.ringConfig3 }
                this.ringConfig4.data = rang_config4;
                this.ringConfig4 = { ...this.ringConfig4 }
                this.$nextTick(() => {
                    console.log(this.$refs.ringConfig);
                    this.DrawEcharts()
                })

            })
        },


        BigScreen() {
            this.IsBigDiv = !this.IsBigDiv;
            if (this.IsBigDiv) {
                this.divHeight = '100vh';
                this.divWidth = '100vw';
            } else {
                this.divHeight = '100%';
                this.divWidth = '100%';
            }

        },


        //  换算方法
        nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;

            return val * (nowClientWidth / initWidth);
        },

        fmoney(s, n = 2) {
            n = n > 0 && n <= 20 ? n : 2
            s = parseFloat((s + '').replace(/[^\d.-]/g, '')).toFixed(n) + ''
            let m = Number(JSON.parse(s)) // 深拷贝数据并转换为number类型
            let num = ''
            let w = '' // 单位
            let l = s.split('.')[0].split('').reverse()
            if (l.length >= 13) {
                num = (m / 1000000000000).toFixed(n)
                w = '万亿'
            } else if (l.length >= 9) {
                num = (m / 100000000).toFixed(n)
                w = '亿'
            } else if (l.length >= 5) {
                num = (m / 10000).toFixed(n)
                w = '万'
            } else {
                num = m.toFixed(n)
                w = ''
            }
            num = parseFloat((num + '').replace(/[^\d.-]/g, '')).toFixed(n) + ''
            let gg = num.split('.')[0].split('').reverse()
            let r = num.split('.')[1] === '00' ? '' : '.' + num.split('.')[1]
            let t = ''
            if (gg[(gg.length - 1)] === '-') {
                let index = gg.findIndex(item => item === '-')
                gg.splice(index, 1)
                for (let i = 0; i < gg.length; i++) {
                    t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? ',' : '')
                }
                t += '-'
            } else {
                for (let i = 0; i < gg.length; i++) {
                    t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? ',' : '')
                }
            }
            return t.split('').reverse().join('') + r + w
        },
    }
}
</script>

<style  scoped>
.flex /deep/ #Myrouterview {
    padding: 0 !important;
    max-height: none !important;
}

.divTitle {
    color: #d6d7dd;
    font-size: 1.1rem;
    margin-left: 0.3125rem;
}

.spanText {
    color: white;
    font-weight: 600;
    font-size: 1.35rem;
}

.spanTextOther {
    color: white;
    font-weight: 400;
    font-size: 0.9375rem;
}

.scrollboard {
    /* background-color: rgba(38,81,207, 0.6); */
    border-radius: 1.5%;
    width: 100%;
    color: white;

}
</style>


// WEBPACK FOOTER //
// src/views/data/userBigscreen.vue